// Define Firestore Timestamp interface for handling Firestore timestamp objects
interface FirestoreTimestamp {
    seconds: number;
    nanoseconds: number;
    toDate?: () => Date;
}

export class Payment{
    paymentUID!: string;
    date!: Date;
    amount!: number;
    isIncome!: boolean;
    currency!: string;
    comment?: string;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(date: Date | FirestoreTimestamp | any, amount: number, currency: string, isIncome: boolean, comment?: string){
        this.date = Payment.convertToDate(date);
        this.amount = amount;
        this.currency = currency;
        this.isIncome = isIncome;
        this.comment = comment;
    }

    /**
     * Helper method to convert Firestore timestamps or other date formats to Date objects
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static convertToDate(date: Date | FirestoreTimestamp | any): Date {
        if (!date) return new Date();
        
        // Handle Firestore timestamp objects
        if (typeof date === 'object' && 'seconds' in date && 'nanoseconds' in date) {
            return new Date(date.seconds * 1000 + date.nanoseconds / 1000000);
        }
        
        // Use toDate() method if available (Firestore timestamp)
        if (typeof date === 'object' && 'toDate' in date && typeof date.toDate === 'function') {
            return date.toDate();
        }
        
        // Already a Date
        if (date instanceof Date) {
            return date;
        }
        
        // String date
        if (typeof date === 'string') {
            return new Date(date);
        }
        
        // Default to current date if can't parse
        try {
            return new Date(date);
        } catch (error) {
            console.error('Error converting date in Payment:', error);
            return new Date();
        }
    }
}
